// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4) return "static/chunks/4-ed29528cb2b02e6c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"505":"150141958b9ae761","627":"9c71f3a392e76d71"}[chunkId] + ".js";
};